import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <polygon points="1 32.35 6.38 24.71 19.53 33.98 41.36 3 49 8.38 21.79 47 1 32.35" />
  </Base>
);
